import React from 'react';

function Footer() {

    return (
        <div className='text-center' style={{background:"linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)"}}>
            <small>© All Rights Reserved By Veg box</small>
        </div>
    )
}

export default Footer;